import TextInput from '../../../components/text-input/text-input.component';
import { IQuestion } from '../interfaces/question.type.js';
import { renderTextWithLinks } from '../utils/text-with-links.utils';
import { useSurveyContext } from '../context/useSurveryContext';
import { Select } from '../../../components/select/select.component';
import SelectEmoji from '../../../components/select-emoji/select-emoji.component';
import styles from '../styles/question-card.module.css';
interface QuestionCardProps {
	question: IQuestion;
}

export default function QuestionCard({ question }: QuestionCardProps) {
	const {
		selectedOption,
		setSelectedOption,
		otherResponse,
		setOtherResponse,
		response,
		setResponse,
	} = useSurveyContext();

	const renderInput = () => {
		switch (question.TIPO_DE_RESPUESTA) {
			case '001':
				return (
					<TextInput
						id={question.ID_PREGUNTA}
						name={question.ID_PREGUNTA}
						value={response}
						onChange={(e) => setResponse(e.target.value)}
						type="text"
						placeholder="Escribe tu respuesta..."
						className="mt-6"
					/>
				);
			case '002':
				return (
					<div className="grid gap-4">
						<Select
							id={question.ID_PREGUNTA}
							name={question.ID_PREGUNTA}
							onChange={(e) => {
								const selected = question.OPCIONES?.find(
									(opt) =>
										opt.ID_RESPUESTA.toString() === e.target.value
								);
								if (selected) {
									setSelectedOption(selected);
									setOtherResponse('');
								}
							}}
							options={
								question.OPCIONES?.map((opt) => ({
									label: String(opt.DENOMINACION),
									value: opt.ID_RESPUESTA.toString(),
								})) ?? []
							}
							value={selectedOption?.ID_RESPUESTA?.toString() || ''}
						/>
						{selectedOption?.TEXTO_ABIERTO && (
							<TextInput
								type="text"
								id={question.ID_PREGUNTA}
								name={question.ID_PREGUNTA}
								value={otherResponse}
								onChange={(e) => setOtherResponse(e.target.value)}
								placeholder="Escribe tu respuesta..."
							/>
						)}
					</div>
				);
			case '003':
				return (
					<div>
						{question.OPCIONES?.map((opt) => (
							<div key={opt.ID_RESPUESTA} className={styles.optionWrapper}>
								<label className={styles.label}>
									<input
										type="radio"
										name="opcion"
										value={opt.ID_RESPUESTA}
										checked={
											selectedOption?.ID_RESPUESTA ===
											opt.ID_RESPUESTA
										}
										onChange={() => {
											setSelectedOption(opt);
											setOtherResponse('');
										}}
										className={styles.radio}
									/>
									<span className={styles.optionText}>
										{opt.DENOMINACION}
									</span>
								</label>
							</div>
						))}
						{selectedOption?.TEXTO_ABIERTO && (
							<TextInput
								id={question.ID_PREGUNTA}
								name={question.ID_PREGUNTA}
								type="text"
								value={otherResponse}
								onChange={(e) => setOtherResponse(e.target.value)}
								className="mt-2 w-full rounded border border-gray-300 p-2"
								placeholder="Escribe tu respuesta..."
							/>
						)}
					</div>
				);
			case '004':
				return (
					<input
						type="date"
						value={response}
						onChange={(e) => setResponse(e.target.value)}
						className={styles['input-date']}
					/>
				);
			case '005':
				return (
					<div style={{ padding: '2px' }}>
						<div style={{ padding: '2px' }}>
							{question.OPCIONES && question.OPCIONES.length > 0
								? question.OPCIONES.map((opt, index) => (
										<div key={index}>
											{renderTextWithLinks(
												opt.DENOMINACION.toString()
											)}
										</div>
								  ))
								: renderTextWithLinks(question.DENOMINACION || '')}
						</div>
					</div>
				);
			case '006':
				return (
					<div style={{ padding: '2px' }}>
						<SelectEmoji
							value={Number(response) || undefined}
							onChange={(selected) => {
								setResponse(String(selected.rating));
							}}
						/>
					</div>
				);
			default:
				return null;
		}
	};

	return (
		<div className={styles.myGrid}>
			<h2 className={styles.title}>{question.DENOMINACION}</h2>
			{renderInput()}
		</div>
	);
}
